(() => {
  if (window.EmslandrostPurchaseDetails) {
    window.EmslandrostPurchaseDetails.init(document);
    return;
  }
  const selector = '[data-em-purchase-details]';
  const instances = new Map();

  class PurchaseDetails {
    constructor(root) {
      this.root = root;
      this.content = root.querySelector('[data-purchase-content]');
      this.status = root.querySelector('[data-purchase-status]');
      this.retry = root.querySelector('[data-purchase-retry]');
      this.variantId = root.dataset.variantId || '';
      this.saleUnit = [...document.querySelectorAll('[data-em-sale-unit]')].find(node => node.dataset.sectionId === root.dataset.sectionId);
      this.revision = 0;
      this.failed = false;
      this.loading = false;
      this.onRetry = () => this.load();
      this.retry.addEventListener('click', this.onRetry);
    }

    message(text, retry = false) {
      this.status.textContent = text;
      this.status.hidden = !text;
      this.retry.hidden = !retry;
    }

    select(variantId) {
      const next = variantId ? String(variantId) : '';
      if (next === this.variantId) {
        if (this.failed && !this.loading) this.load();
        return;
      }
      // Invalidate a pending response immediately, including the debounce period.
      this.revision += 1;
      this.controller?.abort();
      window.clearTimeout(this.timer);
      this.variantId = next;
      this.failed = false;
      this.loading = false;
      this.root.hidden = false;
      this.content.hidden = true;
      this.content.setAttribute('aria-busy', next ? 'true' : 'false');
      if (this.saleUnit) this.saleUnit.hidden = true;
      this.message(next ? 'Bestellinformationen werden geladen …' : 'Bitte wählen Sie eine gültige Ausführung.');
      if (next) this.timer = window.setTimeout(() => this.load(), 120);
    }

    async load() {
      if (!this.variantId || !this.root.isConnected) return;
      window.clearTimeout(this.timer);
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const revision = ++this.revision;
      const variantId = this.variantId;
      this.loading = true;
      this.failed = false;
      this.root.hidden = false;
      this.content.hidden = true;
      this.content.setAttribute('aria-busy', 'true');
      this.message('Bestellinformationen werden geladen …');
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      try {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.root.dataset.sectionId);
        url.searchParams.set('variant', variantId);
        const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Purchase details request failed');
        const html = await response.text();
        if (revision !== this.revision || !this.root.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = [...parsed.querySelectorAll(selector)].find(node =>
          node.dataset.sectionId === this.root.dataset.sectionId
          && node.dataset.blockId === this.root.dataset.blockId
          && node.dataset.productId === this.root.dataset.productId
          && node.dataset.variantId === variantId);
        const content = fresh?.querySelector('[data-purchase-content]');
        if (!content || !['true', 'false'].includes(fresh.dataset.hasContent)) {
          throw new Error('Purchase details response did not match');
        }
        if (fresh.dataset.hasContent === 'true' && !content.querySelector('[data-purchase-field]')) {
          throw new Error('Purchase details response was incomplete');
        }
        // Replace this information card only, leaving checkout and product form intact.
        content.querySelectorAll('script').forEach(script => script.remove());
        this.content.replaceChildren(...Array.from(content.childNodes).map(node => document.importNode(node, true)));
        this.content.hidden = false;
        this.root.dataset.variantId = variantId;
        this.root.dataset.hasContent = fresh.dataset.hasContent;
        this.root.hidden = fresh.hidden;
        const freshUnit = [...parsed.querySelectorAll('[data-em-sale-unit]')].find(node => node.dataset.sectionId === this.root.dataset.sectionId);
        if (this.saleUnit && freshUnit) {
          this.saleUnit.textContent = freshUnit.textContent;
          this.saleUnit.hidden = freshUnit.hidden;
        }
        this.message('');
      } catch (error) {
        if (revision !== this.revision || !this.root.isConnected) return;
        this.failed = true;
        this.message('Die Bestellinformationen konnten nicht geladen werden. Bitte versuchen Sie es erneut.', true);
      } finally {
        window.clearTimeout(timeout);
        if (revision === this.revision) {
          this.loading = false;
          this.controller = null;
          this.content.setAttribute('aria-busy', 'false');
        }
      }
    }

    destroy() {
      this.revision += 1;
      this.controller?.abort();
      window.clearTimeout(this.timer);
      this.retry.removeEventListener('click', this.onRetry);
    }
  }

  function init(scope = document) {
    instances.forEach((instance, root) => {
      if (!root.isConnected) { instance.destroy(); instances.delete(root); }
    });
    const roots = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) roots.unshift(scope);
    roots.forEach(root => {
      if (!instances.has(root) && root.querySelector('[data-purchase-content]')) {
        instances.set(root, new PurchaseDetails(root));
      }
    });
  }
  document.addEventListener('on:variant:change', event => {
    const picker = event.target.closest?.('variant-picker');
    if (picker?.dataset.updateUrl === 'false' || picker?.closest('quick-add-drawer, quick-add, .quick-add')) return;
    const productId = event.detail?.product?.id;
    if (!productId) return;
    instances.forEach((instance, root) => {
      if (root.dataset.productId === String(productId)) instance.select(event.detail?.variant?.id);
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => {
      if (event.target.contains(root)) { instance.destroy(); instances.delete(root); }
    });
  });
  window.EmslandrostPurchaseDetails = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
